<script>
import resizeMixin from './resizeMixin.js';

import Check from '@/assets/icons/checked.svg';
import Cross from '@/assets/icons/cross.svg';
import FireInput from '@/components/inputs/FireInput';
import Pen from '@/assets/listing/pen.svg';

export default {
  name: 'PanelMixin',
  components: {
    Check,
    Cross,
    FireInput,
    Pen,
  },
  mixins: [resizeMixin],
  props: {
    resume: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
    scrollTo: {
      type: Function,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    let sectionName = this.title;
    return {
      sectionName,
      editName: false,
      dontSendNext: false,
    };
  },
  mounted() {
    this.$emitter.on('undo', () => setTimeout(this.updateFields, 10));
    this.$emitter.on('redo', () => setTimeout(this.updateFields, 10));
    if (!this.sectionId) {
      throw new Error('missing data sectionId');
    }
  },
  beforeUnmount() {
    this.$emitter.off('undo');
    this.$emitter.off('redo');
  },
  methods: {
    changeSectionName() {
      if (!this.sectionName) {
        this.sectionName = this.$t(`resume.sections.${this.resume.language || 'fr'}.${this.sectionId}`);
      }

      this.$store.dispatch('resumes.section.title.edit', {
        sectionId: this.sectionId,
        title: this.sectionName,
      });
      this.editName = false;
    },
    undoSectionName() {
      this.sectionName = this.title;
      this.editName = false;
    },
    updateFields() {
      this.items.forEach(item => {
        if (this.$refs[`${item.id}-convictions-field`] && this.$refs[`${item.id}-convictions-field`][0]) {
          this.dontSendNext = true;
          this.$refs[`${item.id}-convictions-field`][0].input = item.content.convictions;
        }
      });
    },
    itemChanged(value, key) {
      if (this.dontSendNext) {
        this.dontSendNext = false;
        return;
      }
      if (this.items.length) {
        const content = JSON.parse(JSON.stringify(this.items[0].content));
        content[key] = value;
        this.$store.dispatch('items.content.edit', {
          itemId: this.items[0].id,
          content,
        });
      } else if (this.item) {
        const content = JSON.parse(JSON.stringify(this.item.content));
        content[key] = value;
        if (this.item.type === 'experiences' && ['client', 'job'].includes(key)) {
          if (content.client && content.job) {
            content.title = content.client + ' - ' + content.job;
          } else if (content.client) {
            content.title = content.client;
          } else {
            content.title = content.job;
          }
        }
        this.$store.dispatch('items.content.edit', {
          itemId: this.item.id,
          content,
        });
      }
    },
  },
};
</script>
